/**
 * Social Media Sharing Component.
 *
 * @author Alvin Yau.
 */

/***
 * Update custom email element's onclick event.
 *
 * The 3rd party ShareThis script has a compatibility issue with Windows and certain iOS devices,
 * generating a malformed email template for the email client.
 */
export function updateCustomEmail() {
    const emails = document.querySelectorAll('div[data-network="email-custom"]');
    for (let i = 0; i < emails.length; i += 1) {
        const subject = emails[i].getAttribute('data-email-subject') || '';
        let url = window.location.href.split('?')[0];
        const canonicalElement = document.querySelector('link[rel="canonical"]');
        if (canonicalElement && canonicalElement.getAttribute('href')) {
            url = canonicalElement.getAttribute('href');
        }
        emails[i].onclick = () => { window.location = `mailto:%20?subject=${subject}&body=${url}`; };
    }
}

updateCustomEmail();
